import React from 'react';
import { Field } from 'react-final-form';
import { getOSOptions } from "../util/config"

export function CentOS(props) {
    const centOSOptions = getOSOptions("Linux")
    return (
    <div>
        <h3>Data Analysis</h3>
        <div>
          <table>
            <tbody>
            {
                centOSOptions["data"].map((option) =>
                <tr key={option.name}>
                  <td>
                    <Field name="software" value={option.name} component="input" type="checkbox" />
                    {' '}<label>{option.desc}</label>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>

        <h3>Database</h3>
        <div>
          <table>
            <tbody>
            {
                centOSOptions["database"].map((option) =>
                <tr key={option.name}>
                  <td>
                    <Field name="software" value={option.name} component="input" type="checkbox" />
                    {' '}<label>{option.desc}</label>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>

        <h3>Bioinformatics</h3>
        <div>
          <table>
            <tbody>
            {
                centOSOptions["bio"].map((option) =>
                <tr key={option.name}>
                  <td>
                    <Field name="software" value={option.name} component="input" type="checkbox" />
                    {' '}<label>{option.desc}</label>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>

        <h3>Image Processing</h3>
        <div>
          <table>
            <tbody>
            {
                centOSOptions["image"].map((option) =>
                <tr key={option.name}>
                  <td>
                    <Field name="software" value={option.name} component="input" type="checkbox" />
                    {' '}<label>{option.desc}</label>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>

    </div>
    );
}
